type ITEMS = {
  id: string | number;
  label: string;
};

export const userRoles: ITEMS[] = [
  {
    id: 1,
    label: 'ผู้ใช้งานทั่วไป / นักเรียน',
  },
  {
    id: 2,
    label: 'ผูู้ปกครอง',
  },
  {
    id: 3,
    label: 'ครู',
  },
];

export const phases = [
  {
    src: 'logo_p1.png',
    key: 'p1',
    label: 'SORNTHAI Alphabet',
    labelth: 'สอนไทย พยัญชนะ',
    className: 'h-5',
  },
  {
    src: 'logo_p2.png',
    key: 'p2',
    label: 'SORNTHAI Vowels',
    labelth: 'สอนไทย สระ',
    className: 'h-5',
  },
  {
    src: 'logo_p3.png',
    key: 'p3',
    label: 'SORNTHAI Basic Blending',
    labelth: 'สอนไทย ประสมคำ',
    className: 'h-8',
  },
  {
    src: 'logo_p4.png',
    key: 'p4',
    label: 'SORNTHAI Basic Spelling',
    labelth: 'สอนไทย ตัวสะกด',
    className: 'h-8',
  },
];
